export default function Bracket({ ...rest }: React.SVGProps<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      type="image/svg+xml"
      xmlSpace="preserve"
      viewBox="0 0 492 492"
      {...rest}
    >
      <path
        d="M424.82 128.156H294.448a5.76 5.76 0 0 1-5.76-5.76V76.878a5.76 5.76 0 0 1 5.76-5.76H424.82a5.76 5.76 0 0 1 5.76 5.76v45.518a5.76 5.76 0 0 1-5.76 5.76zm-124.612-11.52H419.06V82.638H300.208v33.998z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M403.466 163.734h-87.664a5.76 5.76 0 0 1-5.76-5.76v-35.578a5.76 5.76 0 0 1 5.76-5.76h87.664a5.76 5.76 0 0 1 5.76 5.76v35.578a5.76 5.76 0 0 1-5.76 5.76zm-81.904-11.52h76.144v-24.058h-76.144v24.058z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M391.525 324.768h-63.781a5.76 5.76 0 0 1-5.76-5.76V157.974a5.76 5.76 0 0 1 5.76-5.76h63.781a5.76 5.76 0 0 1 5.76 5.76v161.033a5.76 5.76 0 0 1-5.76 5.761zm-58.021-11.521h52.261V163.734h-52.261v149.513z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M386.022 347.773h-52.776a5.76 5.76 0 0 1-5.602-4.42l-5.503-23.005a5.76 5.76 0 1 1 11.204-2.68l4.445 18.585h43.687l4.445-18.585a5.76 5.76 0 1 1 11.204 2.68l-5.503 23.005a5.759 5.759 0 0 1-5.601 4.42z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M391.525 324.768h-63.781a5.76 5.76 0 0 1 0-11.52h63.781a5.76 5.76 0 0 1 0 11.52zM391.525 301.763h-63.781a5.76 5.76 0 0 1 0-11.52h63.781a5.76 5.76 0 0 1 0 11.52zM391.525 278.758h-63.781a5.76 5.76 0 0 1 0-11.52h63.781a5.76 5.76 0 0 1 0 11.52zM391.525 255.754h-63.781a5.76 5.76 0 0 1 0-11.52h63.781a5.76 5.76 0 0 1 0 11.52zM391.525 232.749h-63.781a5.76 5.76 0 0 1 0-11.52h63.781a5.76 5.76 0 0 1 0 11.52zM391.525 209.744h-63.781a5.76 5.76 0 0 1 0-11.52h63.781a5.76 5.76 0 0 1 0 11.52zM391.525 186.739h-63.781a5.76 5.76 0 0 1 0-11.52h63.781a5.76 5.76 0 0 1 0 11.52zM337.905 128.156a5.76 5.76 0 0 1-5.76-5.76V76.878a5.76 5.76 0 0 1 11.52 0v45.518a5.76 5.76 0 0 1-5.76 5.76zM381.363 128.156a5.76 5.76 0 0 1-5.76-5.76V76.878a5.76 5.76 0 0 1 11.52 0v45.518a5.76 5.76 0 0 1-5.76 5.76zM99.887 294.503a5.742 5.742 0 0 1-4.073-1.687L63.628 260.63a5.76 5.76 0 0 1 0-8.146l92.187-92.187a5.76 5.76 0 0 1 8.146 0l32.186 32.186a5.76 5.76 0 0 1 0 8.146l-92.187 92.187a5.746 5.746 0 0 1-4.073 1.687zm-24.04-37.946 24.04 24.04 84.041-84.041-24.04-24.04-84.041 84.041z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M140.144 304.561a5.76 5.76 0 0 1-4.073-1.687l-25.158-25.158a5.76 5.76 0 0 1 0-8.146l61.988-61.987a5.76 5.76 0 0 1 8.146 0l25.158 25.158a5.76 5.76 0 0 1 0 8.146l-61.988 61.988a5.763 5.763 0 0 1-4.073 1.686zm-17.012-30.918 17.012 17.012 53.842-53.842-17.012-17.012-53.842 53.842z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M262.456 409.985a5.742 5.742 0 0 1-4.073-1.687L144.515 294.43a5.76 5.76 0 0 1 0-8.146l45.1-45.1a5.76 5.76 0 0 1 8.146 0l113.868 113.868a5.76 5.76 0 0 1 0 8.146l-45.1 45.1a5.746 5.746 0 0 1-4.073 1.687zM156.734 290.357l105.722 105.722 36.954-36.954-105.722-105.722-36.954 36.954z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M282.612 422.361a5.742 5.742 0 0 1-3.012-.852l-20.158-12.376a5.761 5.761 0 0 1 6.028-9.818l16.285 9.998 30.891-30.891-9.998-16.285a5.76 5.76 0 1 1 9.818-6.028l12.376 20.157a5.762 5.762 0 0 1-.836 7.087l-37.318 37.318a5.753 5.753 0 0 1-4.076 1.69z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
      <path
        d="M262.456 409.985a5.76 5.76 0 0 1-4.073-9.833l45.1-45.1a5.76 5.76 0 0 1 8.146 8.146l-45.1 45.1a5.746 5.746 0 0 1-4.073 1.687zM246.189 393.718a5.76 5.76 0 0 1-4.073-9.833l45.1-45.1a5.76 5.76 0 0 1 8.146 8.146l-45.1 45.1a5.742 5.742 0 0 1-4.073 1.687zM229.922 377.451a5.76 5.76 0 0 1-4.073-9.833l45.1-45.1a5.76 5.76 0 0 1 8.146 8.146l-45.1 45.1a5.742 5.742 0 0 1-4.073 1.687zM213.655 361.184a5.76 5.76 0 0 1-4.073-9.833l45.1-45.1a5.76 5.76 0 0 1 8.146 8.146l-45.1 45.1a5.74 5.74 0 0 1-4.073 1.687zM197.388 344.917a5.76 5.76 0 0 1-4.073-9.833l45.1-45.1a5.76 5.76 0 0 1 8.146 8.146l-45.1 45.1a5.738 5.738 0 0 1-4.073 1.687zM181.122 328.651a5.76 5.76 0 0 1-4.073-9.833l45.1-45.1a5.76 5.76 0 0 1 8.146 8.146l-45.1 45.1a5.746 5.746 0 0 1-4.073 1.687zM164.855 312.384a5.76 5.76 0 0 1-4.073-9.833l45.1-45.1a5.76 5.76 0 0 1 8.146 0 5.76 5.76 0 0 1 0 8.146l-45.1 45.1a5.742 5.742 0 0 1-4.073 1.687zM130.616 263.774a5.742 5.742 0 0 1-4.073-1.687l-32.186-32.186a5.76 5.76 0 0 1 8.146-8.146l32.186 32.186a5.76 5.76 0 0 1-4.073 9.833zM161.345 233.045a5.742 5.742 0 0 1-4.073-1.687l-32.186-32.186a5.76 5.76 0 0 1 8.146-8.146l32.186 32.186a5.76 5.76 0 0 1-4.073 9.833z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#212121",
        }}
      />
    </svg>
  )
}
